<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <h3 class="mb-0 text-uppercase">Attached Documents</h3>
                <hr class="my-4" />
            </div>


            <div
                class="col-sm-6 text-center borderLine"
                v-show="records && records.length > 0"
                v-for="(document, index) in records"
                :key="index"
            >
                <br>
                <input
                    type="file"
                    id="file" style="display: none"
                >
                <h4 class="text-capitalize height-50">
                    <span>{{ document.name }}</span><br><br>
                    <em class="title-font text-danger">
                        {{ document.description }}
                    </em>
                </h4><br><br><br>
                <base-button
                    type="primary"
                    size="sm"
                    @click="viewDocument(document.filename, index)"
                    v-if="document.hasFile"
                >
                    <i class="fa fa-eye"></i> 
                    {{ isLoading && (isIndex == index) ? 'Loading...' : 'View File'}}
                </base-button>
                <badge
                    type="danger"
                    v-if="! document.hasFile"
                >
                    No File Uploaded
                </badge>
                <br><br>
            </div>
 
            <div class="col-lg-12 text-center" v-if="records && records.length == 0">
                <base-alert type="danger">
                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                    <span class="alert-inner--text">
                        <h2 class="text-white">No Attached Documents !!!</h2>
                    </span>
                </base-alert>
            </div>

            <div class="col-lg-12">
                <hr class="my-4" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import Badge from '../../../components/Badge.vue'

    export default {
        components: { Badge },
        name: 'Documents',
        props: [ 'records', 'applicant' ],
        data() {
            return {
                isLoading: false,
                isIndex: null
            }
        },
        computed: {
            ...mapGetters(['getViewRemediationDocumentUrl'])
        },
        methods: {
            ...mapActions(['viewRemediationDocument']),
            async viewDocument(filename, index) {// view user document
                this.isLoading = true;
                this.isIndex = index;
                let data = { 
                    filename : filename, 
                    id : this.applicant.access_token, 
                    url: this.getViewRemediationDocumentUrl
                };                
                this.viewRemediationDocument(data).then(() => {
                    this.isLoading = false;// document will be opened in new tab
                    this.isIndex = null;
                }).
                catch(err => {
                    this.isLoading = false;
                    this.isIndex = null;
                    swal.fire(err.message+"!", "An error occurred while fetching document, try again...", "warning");
                });
            }
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
    .photo-class {
        width: 200px;
        height: 200px;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>